// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__O-KM7","large":"styles_large__3nDeX"};